import React, { Component } from 'react';
import { Container } from 'react-bootstrap';

// Components
import SectionGallery from '../shared/section-gallery/section-gallery';
import { Footer } from '../shared/footer/footer';
import ContactUs from '../contactus/contactus';

class Gallery extends Component {
  render() {
    return (
      <Container fluid={true}>
        <SectionGallery title="Gallery" />
        <ContactUs />
        <Footer />
      </Container>
    );
  }
}

export default Gallery;
